import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { ProductPostPurchaseFeatureDTO } from '../../../api/product-post-purchase-feature-api';
import SvgClose from '../../../assets/icons/Close';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveProductPostPurchaseFeatureModalProps {
    show: boolean;
    allowEdit: boolean;
    onHide: () => void;
    onSave: (values: ProductPostPurchaseFeatureDTO) => void;
}

export function SaveProductPostPurchaseFeatureModal({
    show,
    allowEdit,
    onHide,
    onSave,
}: SaveProductPostPurchaseFeatureModalProps) {
    const ProductPostPurchaseFeatureSchema = yup.object().shape({
        value: yup.string().required(' '),
    });

    const defaultValues: ProductPostPurchaseFeatureDTO = {
        id: 0,
        productId: 0,
        value: '',
        link: '',
    };

    if (!show) return <></>;

    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={ProductPostPurchaseFeatureSchema}
            onSubmit={onSave}
        >
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    depth="3"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>add-post-purchase-feature</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>

                                <bd.Button
                                    disabled={!allowEdit}
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex vertical gap={2}>
                            <FormikTextField
                                label="feature-title"
                                name="value"
                                readOnly={!allowEdit}
                                width="100%"
                                handleEnter
                            />

                            <FormikTextField
                                label="link"
                                name="link"
                                readOnly={!allowEdit}
                                width="100%"
                                placeholder="https://example.com"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}

